import React, { useState } from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { useIntl, FormattedMessage } from 'react-intl'

import { READ, DID_NOT_READ, FEED_READ } from 'app/constants/messageDetail'

import DisplaySubscriber from './DisplaySubscriber'
import StackedBarChart from '../components/StackedBarChart'
import SubscriberListWithTabs from './SubscriberListWithTabs'

const ViewRate = (props) => {
  const { data } = props
  const { read = [], feedRead = [], didntRead = [] } = data || {}

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const readCount = R.isEmpty(data) ? 0 : R.length(read ?? [])
  const feedCount = R.isEmpty(data) ? 0 : R.length(feedRead ?? [])
  const notReadCount = R.isEmpty(data) ? 0 : R.length(didntRead ?? [])

  const subscriberRead = [
    {
      name: READ,
      label: formatMessage({
        id: 'metrics.read',
      }),
      subscribers: read,
      emptyMessage: formatMessage({
        id: 'metrics.feed.read.empty.message',
      }),
    },
    {
      name: FEED_READ,
      label: formatMessage({
        id: 'metrics.feed.read',
      }),
      subscribers: feedRead,
      emptyMessage: formatMessage({
        id: 'metrics.read.empty.message',
      }),
    },
  ]

  const stackedInfo = [
    {
      name: READ,
      color: '#4FD975',
      lableTooltip: null,
      value: readCount,
    },
    {
      name: FEED_READ,
      color: '#FFA700',
      lableTooltip: null,
      value: feedCount,
    },
    {
      name: DID_NOT_READ,
      color: '#EBECF4',
      lableTooltip: (
        <FormattedMessage
          id="metrics.didnt.read.hover.message"
          values={{
            count: notReadCount,
          }}
        />
      ),
      value: notReadCount,
    },
  ]

  return (
    <>
      <div className="space-y-3 px-5 py-10">
        <Typography className="font-bold flex items-center text-grey-400 font-medium">
          {formatMessage({
            id: 'metrics.view.rate',
          })}
        </Typography>
        {R.isEmpty(read) ? null : (
          <div className="flex mt-10">
            <span
              className="w-3 h-3 mt-2 mr-3 rounded-full"
              style={{ backgroundColor: '#4FD975' }}
            />
            <Typography className="text-12 text-grey-400">
              <FormattedMessage
                id="metrics.view.rate.read.message"
                values={{
                  count: readCount,
                }}
              />
            </Typography>
          </div>
        )}
        {R.isEmpty(feedRead) ? null : (
          <div className="flex">
            <span
              className="w-3 h-3 mt-2 mr-3 rounded-full"
              style={{ backgroundColor: '#FFA700' }}
            />
            <Typography className="text-12 text-grey-400">
              <FormattedMessage
                id="metrics.view.rate.feed.read.message"
                values={{
                  count: feedCount,
                }}
              />
            </Typography>
          </div>
        )}
        <StackedBarChart data={stackedInfo} />
        <div className="flex justify-between">
          {R.isEmpty(R.concat(read, feedRead)) ? null : (
            <DisplaySubscriber
              data={R.concat(read, feedRead)}
              onClick={() => setIsOpen(true)}
            />
          )}
        </div>
      </div>

      <SubscriberListWithTabs
        data={subscriberRead}
        title={formatMessage({ id: 'metrics.view.title' })}
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
      />
    </>
  )
}

const object = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.string,
  avatarCharacters: PropTypes.string,
  lastSeen: PropTypes.string,
}
ViewRate.propTypes = {
  data: PropTypes.shape({
    read: PropTypes.arrayOf(PropTypes.shape(object)),
    feedRead: PropTypes.arrayOf(PropTypes.shape(object)),
    didntRead: PropTypes.arrayOf(PropTypes.shape(object)),
  }).isRequired,
}

export default ViewRate
